
// import { BrowserRouter, Route, Switch, Link } from 'react-router-dom';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

import './App.css';

import TemporaryDrawer from './Drawer';

import { Home } from './Home/Home';
import { About } from './About/About';
import { Projects} from './Projects/Projects';
import { Header } from './Header/Header';
import { Footer } from './Footer';
import { Skills } from './Skills/skills';
function App() {
  return (
    <BrowserRouter>
     <Header/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}









export default App;
